module.exports = __webpack_public_path__ + "img/geod_7.93f89464.jpg";